import './Contact.css';


function Contact_en() {
  return (
    <div className="Contact-en" id="Contact">
      <div className='Contact-Body'>
        <div className="content-wrapper">
          <h2 className="contact-heading">To become a partner or for inquiries</h2>
          <a className='link' href="/en/contact-us">
            <button className="contact-button">
              <i className="fas fa-phone"></i> Contact Us
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact_en;
